import React from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../../css/bootstrap-extend.css';
import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router-dom';

class DataTableWrapperForSettingSubscriptionTermination extends React.Component {
  constructor(props) {
    super(props);
  }

  isCheckAll = () => {
    const newData = this.props.subscriptionTerminationCountryData;
    return newData.map(item => item.isSelected).every(item => item) ? newData.length > 0 ? " checked" : "" : "";
  };

  render() {
    return (
        <table className="table unified-border table-hover table-data">
          <caption>{this.props.t("INSTANT_SUBSCRIPTION_TERMINATION")}</caption>
          <colgroup>
            <>
              <col width="30"/>
              <col width="140"/>
              <col width="100"/>
            </>

          </colgroup>
          <thead>
          <tr>
            <th className="none-sort" scope="col">
              <div className="btn-group-toggle btn-group-checkbox btn-check" data-toggle="buttons">
                <label
                    className={"btn-checkbox checkbox-all".concat(this.isCheckAll())}>
                  <input
                      onClick={() => this.props.handleCheckAll()}
                      type="checkbox"/>
                </label>
              </div>
            </th>
            <th scope="col">{this.props.t("COUNTRIES")}</th>
            <th scope="col">{this.props.t("SUBSCRIPTION_TERMINATION_COLUMN_INFO")}</th>
          </tr>
          </thead>
          <tbody className="text-center">
          {
            this.props.subscriptionTerminationCountryData.map((item) => (
                <tr key={item.countryCode}>
                  <td className="text-center">
                    <div className="btn-group-toggle btn-group-checkbox btn-check ">
                      <label
                          className={"btn-checkbox".concat(item.isSelected ? " checked" : "").concat(item.isDisabled ? " disabled" : "")}>
                        <input
                            disabled={item.isDisabled}
                            onClick={() => {
                              this.props.handleCheck(item.countryCode, item.isDisabled)
                            }}
                            type="checkbox"/></label>
                    </div>
                  </td>
                  <td>
                    {this.props.t(item.countryCode)}
                  </td>
                  <td>
                    <div className="col-8 input-group form-inline ml-0">
                      <input
                          className="form-control ml-0"
                          type="number"
                          placeholder={this.props.t('PLACEHOLDER_RANGE_PERIOD_IN_MONTH')}
                          value={item.withdrawalPeriod}
                          min={1}
                          max={31}
                          onChange={(event) => {
                            this.props.handlePeriodTerminationChange(item.countryCode, event);
                          }}/>
                      <h4 className="ml-2 my-auto">{this.props.t('DAY_S')}</h4>
                    </div>
                  </td>
                </tr>
            ))
          }
          </tbody>
        </table>
    );
  }

}

export default withTranslation()(withRouter(DataTableWrapperForSettingSubscriptionTermination));